<script setup>
/**
 * SelectionCards — card-style radio group for profile settings.
 * Syncs visual state with hidden radio inputs inside the parent Rails form.
 */
import { onMounted, ref, watch } from "vue"

const props = defineProps({
  name: { type: String, required: true },
  cardType: { type: String, required: true },
  options: {
    type: Array,
    required: true,
    // [{ value, label, icon?, innerClass?, flag? }]
  },
  selectedValue: { type: String, required: true },
  cardClass: { type: String, default: "theme-card" },
  innerClass: { type: String, default: "theme-card-inner" },
  inputAction: { type: String, default: "" },
})

const activeValue = ref(props.selectedValue)

watch(
  () => props.selectedValue,
  (value) => {
    activeValue.value = value
  }
)

function findRadio(value) {
  return document.querySelector(`input[name="${props.name}"][value="${value}"]`)
}

function selectCard(value) {
  activeValue.value = value
  const radio = findRadio(value)
  if (!radio) return

  radio.checked = true
  radio.dispatchEvent(new Event("change", { bubbles: true }))
}

function syncFromRadios() {
  const checked = document.querySelector(`input[name="${props.name}"]:checked`)
  if (checked) {
    activeValue.value = checked.value
  }
}

onMounted(() => {
  syncFromRadios()
})
</script>

<template>
  <div class="d-flex gap-3 selection-cards">
    <label
      v-for="option in options"
      :key="option.value"
      :class="[cardClass, { active: activeValue === option.value }]"
      :data-card-type="cardType"
      :data-card-value="option.value"
      :data-theme-card="cardType === 'theme' ? option.value : undefined"
      :data-layout-card="cardType === 'layout' ? option.value : undefined"
      @click.prevent="selectCard(option.value)"
    >
      <div :class="[innerClass, option.innerClass]">
        <i v-if="option.icon" :class="[option.icon, 'fa-2x', 'mb-2']" />
        <span v-if="option.flag" class="lang-flag">{{ option.flag }}</span>
        <span>{{ option.label }}</span>
      </div>
    </label>
  </div>
</template>
